import { client } from "utils";

export const getInitialScrapeTasksStatisticRequest = (filterParams) => client.post("initial-scrape-tasks/search", filterParams);
